import './styles/toggle.css';
import { playSound, preloadSounds } from '../utils/soundEffectHelper';
import { useGameStore } from '../../store/gameStore';
import { useState } from 'react';

interface ToggleProps {
  selected: boolean;
  muteSoundWhenOff?: boolean;
  setSelected: (selected: boolean) => void;
}

function Toggle(props: ToggleProps) {
  const { selected, muteSoundWhenOff, setSelected } = props;

  const [soundsPreloaded, setSoundsPreloaded] = useState<boolean>(false);

  const handleClick = () => {
    const shouldPlaySound = muteSoundWhenOff ? !selected : true;
    setSelected(!selected);
    if (!soundsPreloaded) {
      preloadSounds();
      setSoundsPreloaded(true);
    }
    if (useGameStore.getState().soundEnabled && shouldPlaySound) playSound('switchClick');
  };

  return (
    <button
      onClick={handleClick}
      className={`toggle-button ${selected ? 'toggle-selected' : ''}`}
      role="switch"
      aria-checked={selected}
    >
      <span className={`toggle-thumb ${selected ? 'toggle-thumb-selected' : ''}`} />
    </button>
  );
}

export default Toggle;
